import { render, staticRenderFns } from "./RenameGroup.vue?vue&type=template&id=0c5cbddf&scoped=true&"
import script from "./RenameGroup.vue?vue&type=script&lang=ts&"
export * from "./RenameGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RenameGroup.vue?vue&type=style&index=0&id=0c5cbddf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cbddf",
  null
  
)

export default component.exports